import Auth from '@Services/Auth';
import { institutionReducerKey } from './InstitutionConstants';

export const institution = (state) => state.get(institutionReducerKey);

export const isLoading = (state) => institution(state).get('isLoading');

export function ipAddress(state) {
  return institution(state).get('ipAddress');
}

export function isAnonymousUser() {
  return Auth && Auth.isAnonymousUser();
}

export function notifications(state) {
  return institution(state).get('notifications');
}

export function institutionsForSearch(state) {
  return institution(state).get('institutionsForSearch');
}

export function institutionsGroups(state) {
  return institution(state).get('institutionsGroups');
}

export function actualData(state) {
  return institution(state).get('actualData');
}
